module.exports = __webpack_public_path__ + "6617faaae096f9feb3680872ca180f17.svg";